<template>
  <div id="app">
    <notifications
      group="notification"
      position="bottom right"
      width="325"
      animation-type="velocity"
    />
    <router-view />
    <prompt-modal :parameters="promptModalData" />
  </div>
</template>

<script>
import PromptModal from "@/components/PromptModal.vue";

export default {
  name: "app",
  data() {
    return {
      promptModalData: {
        title: "Oops!",
        message: "",
        buttonText: "OK",
      },
    };
  },
  components: {
    PromptModal,
  },
  created() {
    document.title = "RUSH Self Serve";
  },
  mounted() {
    window.Xendit.setPublishableKey(process.env.VUE_APP_XENDIT_PUBLISHABLE_KEY);
    this.$root.$on("showPromptModal", (parameters) => {
      this.promptModalData = { ...this.promptModalData, ...parameters };
      this.$root.$emit("bv::show::modal", "prompt-modal");
    });
    window.fbq("init", process.env.VUE_APP_FB_PIXEL_ID);
    window.fbq("track", "PageView");
  },
};
</script>
